<template>
  <button class="vv-button" @click="onClick" :disabled="disabled" v-bind:class="customClass">
    <slot>Button</slot>
  </button>
</template>

<script>
export default {
  name: 'VvSplashButton',
  props: {
    disabled: Boolean,
    customClass: String
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.vv-button {
  padding: 10px 38px;
  border: 0;
  border-radius: 20px;
  color: $primary;
  font-size: 14px;
  font-weight: 900;
  background-color: white;
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  &:disabled {
    opacity: 0.41;
  }
}

.full-width {
  width: 100%;
}

.user-form-width {
  width: 76%;
}

.no-shadow {
  box-shadow: none;
}

</style>
